import { useState } from 'react';
import { Grid, Button } from '@material-ui/core';
import RoleModel from './roleModel';

const AddRole = () => {
	const [showModal, setShowModal] = useState(false);

	//Close model
	const closeModal = () => {
		setShowModal(false);
	};

	return (
		<Grid container justifyContent="flex-end">
			<Grid item>
				<Button
					variant="contained"
					color="primary"
					onClick={() => setShowModal(true)}
					endIcon={<img
						src={'/assets/icons/admin/project-add.svg'}
						alt={'img'}
					/>}
				>Add Role</Button>
				{showModal && (<RoleModel open={showModal} onClose={closeModal} from="add" />)}
			</Grid>
		</Grid>
	)
}
export default AddRole;

